/*
 *
 * CredentialTypeList actions
 *
 */

import {
  RECEIVE_CREDENTIAL_TYPES,
} from './constants';

export function receiveCredentialTypes(credentialTypes) {
  return {
    type: RECEIVE_CREDENTIAL_TYPES,
    credentialTypes,
  };
}
